// frontend/src/components/SectionTitle.tsx
//
// Унифицированный заголовок секции на дашборде.

import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

interface Props {
  title: string;
  icon?: LucideIcon;
  description?: string;
  rightSlot?: ReactNode;
}

export function SectionTitle({ title, icon: Icon, description, rightSlot }: Props) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
      {Icon && (
        <Icon size={16} strokeWidth={2.25} color="var(--text-secondary)" />
      )}
      <div>
        <h3
          style={{
            margin: 0, fontSize: 14, fontWeight: 600, color: "var(--text-primary)",
            textTransform: "uppercase", letterSpacing: "0.05em",
          }}
        >
          {title}
        </h3>
        {description && (
          <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 1 }}>
            {description}
          </div>
        )}
      </div>
      <span style={{ flex: 1 }} />
      {rightSlot}
    </div>
  );
}
